export const dashboard_header = {
  title: "Dashboard",
  sync_now: "Sync now",
  sync_success: "Synced {upserted} of {scanned} transactions",
  sync_error: "Could not sync Mercury transactions",
};
